// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { mevTestnet as _mevTestnet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the mevTestnet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 4759
 * Chain Name: MEVerse Chain Testnet
 * Default Block Explorer: https://testnet.meversescan.io/
 * Default RPC URL: https://rpc.meversetestnet.io
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { mevTestnet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: mevTestnet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const mevTestnet = createCommon({
	..._mevTestnet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
